<template>
  <div class="Moregister" id="Moregister">
    <div class="Moregister_head">
      <router-link :to="{name:'MoPersonal'}">
        <i class="iconfont icon-fanhui"></i>
      </router-link>
    </div>
    <div class="Moregister_cont">
      <div class="cont_tit">
        <p class="cont_tit_p">找回密码</p>
        <i class="line"></i>
      </div>
      <el-form size="small" :model="form" :rules="formRules" ref="findpswFormA" class="main_form" v-show="findOne">
        <div class="regCont_div">
          <i class="iconfont icon-shouji"></i>
          <el-form-item prop="findpswCell">
            <el-input placeholder="请输入手机号" v-model="form.findpswCell"></el-input>
          </el-form-item>
        </div>
        <div class="regCont_div verCode">
          <el-input placeholder="请输入验证码" @keyup.enter.native="findStep" oninput="if(value.length>4)value=value.slice(0,4)" v-model="form.findpswCode"></el-input>
          <el-button class="sendCode" style="padding:0px;" v-if="isShowGetCode" @click="ActiCode()">获取验证码</el-button>
          <el-button class="sendCode" style="padding:0px;" v-else>{{countdown}}后可重试</el-button>
        </div>
        <div class="regCont_div regibtn" @click="findStep()">
          下一步
        </div>
      </el-form>
      <el-form size="small" :model="form" :rules="formRules" ref="findpswFormB" class="main_form" v-show="findTwo">
        <div class="regCont_div">
          <i class="iconfont icon-mima"></i>
          <el-form-item prop="findPassword">
            <el-input placeholder="请输入密码" type="password" v-model="form.findPassword"></el-input>
          </el-form-item>
        </div>
        <div class="regCont_div">
          <i class="iconfont icon-mima"></i>
          <el-form-item prop="ReAginPassword">
            <el-input placeholder="再次输入密码" type="password" v-model="form.ReAginPassword"></el-input>
          </el-form-item>
        </div>
        <div class="regCont_div regibtn" @click="accomplish()">
          完成
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>  
import validate from '../../assets/unit/validate';
export default {
  data() {
    const VALIDATE_MOBILE_NO = (rule, value, callback) => {
      if (!validate.validateMobile(value)) {
        callback(new Error("手机号需为11位数字"));
      } else {
        callback();
      }
    };
    const VALIDATE_PASSWORD = (rule, value, callback) => {
      if (!validate.validatePassword(value)) {
        callback(new Error('密码必须包含字母和数字且密码长度为6-20个字符'));
      } else {
        callback();
      }
    };
    return {
      // 用户id
      AuthorId: '',
      // 注册发送验证码
      countdown: 60,
      timer: '',
      findOne: true,
      findTwo: false,
      isShowGetCode: true,
      callbackurl: '',
      form: {
        findpswCell: '',
        findpswCode: '',
        findPassword: '',
        ReAginPassword: '',
      },
      formRules: {
        findpswCell: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: VALIDATE_MOBILE_NO, trigger: 'blur' }
        ],
        findPassword: [
          { validator: VALIDATE_PASSWORD, trigger: 'blur' },
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        ReAginPassword: [
          { validator: VALIDATE_PASSWORD, trigger: 'blur' },
          { required: true, message: "密码不能为空", trigger: "blur" },
        ]
      }
    }
  },
  methods: {
    // 完成
    accomplish() {

      this.$refs.findpswFormB.validate(valid => {
        if (valid) {
          if (this.form.findPassword != this.form.ReAginPassword) {
            this.$msgmodal({
              title: '系统提示',
              content: '两次密码不同，请确认密码',
              type: 'warn',
            });
          } else {
            this.httphelper.post('api/LoginApi/UpdateUserPwd',
              {
                phoneNumber: this.form.findpswCell,
                pwd: this.form.findPassword
              }).then((res) => {
                if (res.data.code == 205) {
                  this.$msgmodal({
                    title: '系统提示',
                    content: '修改失败',
                    type: 'warn',
                  });
                } else if (res.data.code == 200) {

                  this.$msgmodal({
                    title: '系统提示',
                    content: '修改成功，前往登录',
                    type: 'warn',
                  });

                  this.$router.push({
                    path: '/mologin',
                    query: {
                      findpswCell: this.form.findpswCell,
                      callback: decodeURIComponent(this.callbackurl)
                    }
                  })
                }
              })
          }
        }
      })
    },
    // 下一步
    findStep() {
      this.$refs.findpswFormA.validate(valid => {
        if (valid) {
          if (this.form.findpswCode == '') {

            this.$msgmodal({
              title: '系统提示',
              content: '请输入验证码!',
              type: 'warn',
            });
          } else {
            this.httphelper.post('/api/VerifCodeApi/NoteVerifCodeOk',
              {
                type: 2,
                phoneNumber: this.form.findpswCell,
                vcode: this.form.findpswCode,
                authorId: 0 //this.AuthorId
              }).then((res) => {
                if (res.data.code == 234) {

                  this.$msgmodal({
                    title: '系统提示',
                    content: '验证码失效!',
                    type: 'warn',
                  });
                } else if (res.data.code == 205) {

                  this.$msgmodal({
                    title: '系统提示',
                    content: '验证码错误!',
                    type: 'warn',
                  });
                } else if (res.data.code == 200) {
                  this.$msgmodal({
                    title: '系统提示',
                    content: '验证通过!',
                    type: 'success',
                  });
                  this.findOne = false
                  this.findTwo = true
                }
              })
          }
        }
      })
    },

    // 验证码数字变化
    countDown() {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    },

    // 获取验证码
    ActiCode() {
      if (this.form.findpswCell == '') {

        this.$msgmodal({
          title: '系统提示',
          content: '手机号不能为空!',
          type: 'warn',
        });
      } else {
        this.httphelper.post('/api/VerifCodeApi/NoteVerifCode',
          {
            type: 2,
            phoneNumber: this.form.findpswCell
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: '发送成功',
                type: 'success'
              });
              this.isShowGetCode = false
              this.countDown()
            } else if (res.data.code == 231) {

              this.$msgmodal({
                title: '系统提示',
                content: '手机号已存在，请直接登录!',
                type: 'warn',
              });
              clearInterval(this.timer)
            } else if (res.data.code == 233) {

              this.$msgmodal({
                title: '系统提示',
                content: '发送失败!',
                type: 'warn',
              });
              clearInterval(this.timer)
            }
          })
      }

    },
  },
  created() {
    /** 获取callback地址 */
    if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'callback')) {
      this.callbackurl = encodeURIComponent(this.$route.query.callback);
    }
  },
}
</script>
<style  scoped>
.Moregister_head {
    padding-left: 10px;
    text-align: center;
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    background: #fff;
    height: 40px;
    z-index: 99;
    line-height: 60px;
}
.Moregister_head >>> a {
    position: absolute;
    left: 30px;
}

.Moregister_cont {
    width: 100%;
    position: relative;
    top: 38px;
}
.cont_tit {
    width: 76px;
    margin-left: 30px;
    margin-top: 50px;
}
.cont_tit_p {
    color: #157eff;
    font-size: 18px;
}
.cont_tit >>> .line {
    width: 30px;
    height: 4px;
    background: #0082fe;
    border-radius: 2px;
    display: inherit;
    margin: 0 auto;
    margin-top: 10px;
}

.main_form {
    width: 80%;
    height: auto;
    margin: 0 auto;
    margin-top: 45px;
}
.regCont_div {
    width: 100%;
    height: 42px;
    border-bottom: 1px solid #ebebeb;
    margin-bottom: 27px;
    line-height: 42px;
    position: relative;
}
.regCont_div >>> .el-form-item {
    position: absolute;
    top: 0;
    width: 84%;
    height: 100%;
    margin-left: 40px;
}
.regCont_div >>> .el-input__inner {
    border: none;
    height: 42px;
    line-height: 42px;
    color: #878787;
    font-size: 15px;
}

.verCode >>> .el-input {
    width: 60%;
    float: left;
    border-bottom: 1px solid #ebebeb;
}
.sendCode {
    width: 34%;
    height: 40px;
    background: #e9f5ff;
    border: 1px solid #157eff;
    float: left;
    color: #157eff;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    margin-left: 15px;
    cursor: pointer;
}
.regibtn {
    width: 100%;
    margin: 0 auto;
    height: 34px;
    background: #157eff;
    box-shadow: 0px 1px 10px 0px rgba(21, 126, 255, 0.5);
    border-radius: 17px;
    margin-top: 49px;
    text-align: center;
    line-height: 34px;
    color: #ffffff;
    font-size: 16px;
}

.regCont_div >>> i {
    color: #878787;
    font-size: 21px;
    margin-left: 17px;
}
</style>
 